import * as React from 'react';
import accounting from 'accounting';
import Modal from 'src/components/common/Modal';
import Carousel from 'src/components/PartDetailsModel/PartDetailsModelDesktop/components/Carousel';
import Alert from 'src/components/common/Alert';
import Button from 'src/components/common/Button';
import IconMessage from 'src/components/common/IconMessage';
import FinalWarehouseCheck from 'src/components/common/FinalWarehouseCheck';
import ProductShipFromModal from 'src/components/common/ProductShipFromModal';

import cartService from 'src/services/cart/CartService';
import { IWarrantyProvider } from 'src/model/warranty.model';
import LocationModel from 'src/model/location.model';

import defaultImage from 'src/assets/defaultImage';
import './PartDetailsModelDesktop.scss';
import {
  ifLoggedIn,
  goToPartDetail,
  goToCart,
  cartUrl
} from 'src/utils/navigation';
import { getExtraStatus } from 'src/components/PartDetails/PartDetailsDesktop/PartDetailsDesktop';
import { IPartModel } from 'src/model/product.model';
import AddToListMenu from 'src/components/AddToListMenu';
import env from 'src/shared/env';
import { startEndWithWhiteSpacesValidation } from 'src/utils/whiteSpacesValidation';
import { linkLocationsToWarehouses } from 'src/utils/partsBusinessLogic';
import UserModel from 'src/model/user.model';

interface IPartDetailsModelDesktopProps {
  part: IPartModel;
  partAddress: any;
  showOnlyMSRP: boolean;
  isLoggedIn: boolean;
  cartDeliverLocationCode: string;
  cartDeliverLocation: LocationModel;
  cartDeliverMethod: string;
  cartItemsCount: number;
  userData: UserModel;
  ref: any;
  handleClose: () => void;
  t: any;
  updateCart: () => void;
  warranties: IWarrantyProvider[];
  getWarranties: () => void;
  scrollToTop: () => void;
}

interface IPartDetailsModelDesktopState {
  qty: number;
  shipmentMarking: string;
  ticketNumber: string;
  warrantyProvider: string;
  warrantyProviderCode: string;
  claims: string;
  mainImage: string;
  showModalImage: boolean;
  showDropDown: boolean;
  showBackorderAlert: boolean;
  showCartAlert: boolean;
  cartAlertType: string;
  addToCartLoading: boolean;
  showButtonAlert: boolean;
  showShipmentAlert: boolean;
  showTicketNumberAlert: boolean;
  showDispatchClaimsAlert: boolean;
  cartAlertMessage: string;
  showShipFromModal: boolean;
  showFinalWarehouseCheck: boolean;
  shipFromOrder: object;
  shippingList: any[];
  noPickUpList: any[];
}

class PartDetailsModelDesktop extends React.Component<
  IPartDetailsModelDesktopProps,
  IPartDetailsModelDesktopState
> {
  private ref: HTMLElement;

  constructor(props: any) {
    super(props);
    this.state = {
      qty: 1,
      shipmentMarking: '',
      ticketNumber: '',
      warrantyProvider: '',
      warrantyProviderCode: '',
      claims: '',
      mainImage: this.getMainImage(),
      showModalImage: false,
      showDropDown: false,
      showBackorderAlert: false,
      showCartAlert: false,
      cartAlertType: '',
      addToCartLoading: false,
      showButtonAlert: false,
      showDispatchClaimsAlert: false,
      showShipmentAlert: false,
      showTicketNumberAlert: false,
      cartAlertMessage: '',
      showShipFromModal: false,
      showFinalWarehouseCheck: false,
      shipFromOrder: {},
      shippingList: [],
      noPickUpList: []
    };
  }

  private getMainImage = () => {
    return this.props.part.images
      ? this.props.part.images[0]
        ? this.props.part.images[0]
        : defaultImage
      : defaultImage;
  };

  private handleInputQtyChange = (e: any) => {
    const warehouseQty =
      this.props.cartItemsCount === 0 ||
      this.props.cartDeliverMethod.toLocaleLowerCase() === 'shipping'
        ? this.props.part.warehouseQty
        : this.props.part.warehouses.find(
            warehouse =>
              this.props.cartDeliverLocationCode === warehouse.warehouseCode
          ).quantity;
    if (Number(e.target.value) > Number(warehouseQty)) {
      this.setState({ showBackorderAlert: true, qty: e.target.value });
    } else {
      this.setState({ showBackorderAlert: false, qty: e.target.value });
    }
  };

  private handleInputShipmentMarkingChange = (e: any) => {
    const shipmentMarking = e.target.value;

    if (
      !shipmentMarking ||
      (shipmentMarking !== ' ' &&
        !startEndWithWhiteSpacesValidation(shipmentMarking))
    ) {
      this.setState({
        shipmentMarking
      });

      if (shipmentMarking.length === 30) {
        this.setState({
          showShipmentAlert: true
        });
      } else {
        this.setState({
          showShipmentAlert: false
        });
      }
    }
  };

  private handleInputTicketNumberChange = (e: any) => {
    const ticketNumber = e.target.value;

    if (
      !ticketNumber ||
      (ticketNumber !== ' ' && !startEndWithWhiteSpacesValidation(ticketNumber))
    ) {
      this.setState({
        ticketNumber
      });

      if (ticketNumber.length === 10) {
        this.setState({
          showTicketNumberAlert: true
        });
      } else {
        this.setState({
          showTicketNumberAlert: false
        });
      }
    }
  };

  private handleSelectWarrantyProviderChange = (
    warranty: IWarrantyProvider
  ) => {
    this.setState({
      warrantyProviderCode: warranty.providerNumberString,
      warrantyProvider: warranty.warrantyClaimNumber
    });
  };

  private handleInputClaimsChange = (e: any) => {
    const claims = e.target.value;

    if (
      !claims ||
      (claims !== ' ' && !startEndWithWhiteSpacesValidation(claims))
    ) {
      this.setState({
        claims
      });
      if (claims.length >= 15) {
        this.setState({
          showDispatchClaimsAlert: true
        });
      } else {
        this.setState({
          showDispatchClaimsAlert: false
        });
      }
    }
  };

  private handleClicMiniImage = (image: string) => {
    this.setState({ mainImage: image });
  };

  private handleClicMainImage = () => {
    this.setState({ showModalImage: true });
  };

  private handleCloseImageModal = () => {
    this.setState({ showModalImage: false });
  };

  private handleCloseAlert = () => {
    this.setState({ showBackorderAlert: false });
  };

  private handleShowDropDown = () => {
    this.setState(prevState => {
      return { showDropDown: !prevState.showDropDown };
    });
  };

  /* 
    buildCartAlert: Prepares data to show on cart Alert
   */
  private buildCartAlert = () => {
    const alertConfig = {
      message: '',
      icon: '',
      type: ''
    };
    switch (this.state.cartAlertType) {
      case 'success':
        alertConfig.message = 'common.itemsAddedToCart';
        alertConfig.icon = 'rpds-check-circle';
        alertConfig.type = 'success';
        break;

      case 'error':
        alertConfig.message = this.state.cartAlertMessage
          ? this.state.cartAlertMessage
          : 'common.errorHasOcurred';
        alertConfig.icon = 'rpds-error';
        alertConfig.type = 'error';
        break;

      case 'mixedCart':
        alertConfig.message = 'partDetails.cartMixedMethodProhibited';
        alertConfig.icon = 'rpds-error';
        alertConfig.type = 'error';
        break;
      case 'wrongShippingAddress':
        alertConfig.message = 'partDetails.cartWrongAddressProhibited';
        alertConfig.icon = 'rpds-error';
        alertConfig.type = 'error';
        break;

      default:
        break;
    }

    return alertConfig;
  };

  /* 
    handleOpenCartAlert
   */
  private handleOpenCartAlert = (
    type: 'success' | 'error' | 'mixedCart' | 'wrongShippingAddress',
    message?: string
  ) => {
    this.setState({
      showCartAlert: true,
      cartAlertType: type,
      cartAlertMessage: message ? message : ''
    });
    this.props.scrollToTop();
  };

  /* 
    handleCloseCartAlert : close add cart alert
   */
  private handleCloseCartAlert = () => {
    this.setState({
      showCartAlert: false,
      cartAlertType: '',
      cartAlertMessage: ''
    });
  };

  private handleOnClicDetails = () => {
    ifLoggedIn(() =>
      goToPartDetail(
        this.props.part.replacedPart
          ? `${
              this.props.part.replacedMfc
                ? this.props.part.replacedMfc + '  '
                : ''
            }${this.props.part.replacedPart}`
          : `${
              this.props.part.manufacturerCode
                ? this.props.part.manufacturerCode + '  '
                : ''
            }${this.props.part.productNumber}`
      )
    );
  };

  private handleShowChangeShipFrom = () => {
    this.setState({
      showShipFromModal: true,
      showFinalWarehouseCheck: false
    });
    window.scrollTo(0, 0);
  };

  private handleChangeShipFrom = (selectedAddresses: object) => {
    const newAddresses: string[] = [];
    let qty: number = 0;
    this.state.shippingList.forEach(address => {
      if (selectedAddresses.hasOwnProperty(address.warehouseCode)) {
        selectedAddresses[address.warehouseCode] = {
          ...selectedAddresses[address.warehouseCode],
          available: address.quantity
        };
        if (address.addressLine4) {
          newAddresses.push(
            `${address.addressLine4.toLocaleLowerCase()} ${address.stateCode}`
          );
        } else {
          newAddresses.push(`${address.name}`);
        }
      }
    });
    for (const key in selectedAddresses) {
      if (selectedAddresses.hasOwnProperty(key)) {
        qty += Number(selectedAddresses[key].qty);
      }
    }
    this.addToCart(selectedAddresses);
    this.setState({
      showShipFromModal: false,
      shipFromOrder: selectedAddresses,
      qty
    });
  };

  private handleCloseChangeShipFrom = () => {
    this.setState({ showShipFromModal: false });
  };

  private handleCloseFinalWarehouseCheck = () => {
    this.setState({ showFinalWarehouseCheck: false });
  };

  private linkWarehouses = (): any => {
    const list: any[] = linkLocationsToWarehouses(
      this.props.part.warehouses,
      this.props.part.locations
    );
    let noPickUpList: any[] = [];
    if (env.REACT_APP_BASE_ENVIRONMENT === 'CA') {
      noPickUpList = list;
    } else {
      list.forEach(element => {
        if (!element.pickUpOnly) {
          noPickUpList.push(element);
        }
      });
    }
    this.setState({ shippingList: list, noPickUpList });
  };

  private handleClickAddToCart = () => {
    if (
      (this.props.cartItemsCount === 0 && !this.props.userData.pickup) ||
      this.props.cartDeliverMethod.toLocaleLowerCase() === 'shipping'
    ) {
      if (this.state.showBackorderAlert) {
        this.linkWarehouses();
        if (
          this.props.part.state.toLowerCase() === 'available' &&
          this.props.part.state.toLowerCase() === 'in stock'
        ) {
          this.setState({
            showFinalWarehouseCheck: true
          });
        } else {
          this.addToCart({ [this.props.part.warehouseCode]: this.state.qty });
        }
      } else {
        this.addToCart({ [this.props.part.warehouseCode]: this.state.qty });
      }
    } else if (this.props.cartItemsCount === 0 && this.props.userData.pickup) {
      this.addToCart({ [this.props.part.warehouseCode]: this.state.qty });
    } else {
      this.addToCart({ [this.props.cartDeliverLocationCode]: this.state.qty });
    }
  };

  private addToCart = (shipFrom: object): void => {
    this.setState({ addToCartLoading: true });
    for (const key in shipFrom) {
      if (shipFrom.hasOwnProperty(key)) {
        cartService
          .addItem(
            this.state.claims,
            this.props.cartItemsCount === 0
              ? this.props.userData.pickup
                ? 'Pick-Up'
                : 'Shipping'
              : this.props.cartDeliverMethod,
            null, // this.props.partAddress.number,
            null,
            this.props.part.name,
            Number(shipFrom[key].qty) < this.state.qty
              ? parseInt(shipFrom[key].qty, 10)
              : this.state.qty,
            false,
            this.state.shipmentMarking,
            key,
            this.state.ticketNumber,
            this.state.warrantyProviderCode
          )
          .then(res => {
            this.handleOpenCartAlert('success');
            this.setState({ addToCartLoading: false });
            this.props.updateCart();
            this.showButtonAlert();
          })
          .catch(e => {
            if (e.toString().includes('code 409')) {
              if (
                e.response.data === 'Location does not match previous cart info'
              ) {
                this.handleOpenCartAlert('wrongShippingAddress');
              } else {
                this.handleOpenCartAlert('mixedCart');
              }
            } else {
              this.handleOpenCartAlert('error', e.response.data);
            }
            this.setState({ addToCartLoading: false });
          });
      }
    }
  };

  /* 
    showButtonAlert
   */
  private showButtonAlert = () => {
    this.setState({ showButtonAlert: true }, () => {
      setTimeout(() => {
        this.setState({ showButtonAlert: false });
      }, 3000);
    });
  };

  /* 
    getAddToCartButton
   */
  private getAddToCartButton = () => {
    const { t } = this.props;
    if (this.state.showButtonAlert) {
      return (
        <div className="success-button-alert">
          <i className="rpds-check-circle" />
          {t('common.itemsAddedToCart')}
        </div>
      );
    } else {
      const addCartButtonStatusDisabled =
        this.state.qty.toString() === '0' ||
        !this.state.qty ||
        this.state.addToCartLoading
          ? true
          : false;
      return (
        <Button
          width={'30%'}
          height={'48px'}
          buttonClass="primary-custom-button rp-part-details-model-desktop--form--button button-cart"
          label={t('common.addToCart')}
          icon={{ position: 'left', icon: 'rpds-shopping-cart' }}
          textTransform="uppercase"
          action={this.handleClickAddToCart}
          disabled={addCartButtonStatusDisabled}
        />
      );
    }
  };

  public componentDidUpdate(prevProps: IPartDetailsModelDesktopProps) {
    if (prevProps.part.name !== this.props.part.name) {
      this.setState({
        showBackorderAlert: this.props.part.warehouseQty < 1,
        showCartAlert: false,
        mainImage: this.props.part.images
          ? this.props.part.images[0]
            ? this.props.part.images[0]
            : defaultImage
          : defaultImage,
        qty: 1,
        shipmentMarking: '',
        ticketNumber: '',
        claims: ''
      });
    }
  }

  public componentDidMount() {
    this.props.getWarranties();
    const warehouseQty =
      this.props.cartItemsCount === 0 ||
      this.props.cartDeliverMethod.toLocaleLowerCase() === 'shipping'
        ? this.props.part.warehouseQty
        : this.props.part.warehouses.find(
            warehouse =>
              this.props.cartDeliverLocationCode === warehouse.warehouseCode
          ).quantity;
    this.setState({
      showBackorderAlert: warehouseQty < 1,
      showCartAlert: false,
      mainImage: this.props.part.images
        ? this.props.part.images[0]
          ? this.props.part.images[0]
          : defaultImage
        : defaultImage,
      qty: 1,
      shipmentMarking: '',
      ticketNumber: '',
      claims: ''
    });
  }

  public render() {
    const { t } = this.props;
    const addCartButtonStatusDisabled =
      this.state.qty.toString() === '0' ||
      !this.state.qty ||
      this.state.addToCartLoading
        ? true
        : false;
    const alertConfig = this.buildCartAlert();

    return (
      <div
        className="rp-part-details-model-desktop Roboto"
        ref={(ref: HTMLElement) => (this.ref = ref)}
      >
        <ProductShipFromModal
          show={this.state.showShipFromModal}
          onClose={this.handleCloseChangeShipFrom}
          type={'shipping'}
          defaultWarehouse={this.props.part.warehouseCode}
          supplierQuantity={Number(this.props.part.supplierQuantity)}
          deliverAddressesList={
            env.REACT_APP_BASE_ENVIRONMENT === 'CA'
              ? this.state.shippingList
              : this.state.noPickUpList
          }
          deliveryLocationCode={this.props.cartDeliverLocationCode}
          handleChangeShipFrom={this.handleChangeShipFrom}
          buttonVerbiage={'Add to cart'}
          selectedAddresses={
            this.props.cartItemsCount === 0 ||
            this.props.cartDeliverMethod.toLocaleLowerCase() === 'shipping'
              ? {
                  [this.props.part.warehouseCode]: {
                    qty: this.state.qty
                  }
                }
              : {
                  [this.props.cartDeliverLocationCode]: {
                    qty: this.state.qty
                  }
                }
          }
          selectedPartState={this.props.part.state}
          selectedPartQty = {this.state.qty}
        />
        {this.state.showFinalWarehouseCheck && (
          <FinalWarehouseCheck
            handleAddToCart={() =>
              this.addToCart({
                [this.props.part.warehouseCode]: this.state.qty
              })
            }
            onClose={this.handleCloseFinalWarehouseCheck}
            handleChangeWarehouse={this.handleShowChangeShipFrom}
          />
        )}
        <div className="rp-part-details-model-desktop--cart-alert">
          {this.state.showShipmentAlert && (
            <Alert
              styleClass="addToCartAlert"
              message={
                // 'Maximum allowable length for Shipment marking is 30 characters'
                `${t('productFieldErrors.maxShipmentCharacterErr', {
                  count: 30
                })}`
              }
              icon={'rpds-warning'}
              handleCloseAlert={() => {
                this.setState({
                  showShipmentAlert: false
                });
              }}
              type={'warning'}
            />
          )}
          {this.state.showTicketNumberAlert && (
            <Alert
              styleClass="addToCartAlert"
              message={
                // 'Maximum allowable length for Ticket/Dispatch number is 10 characters'
                `${t('productFieldErrors.maxTicketCharactersErr', {
                  count: 10
                })}`
              }
              icon={'rpds-warning'}
              handleCloseAlert={() => {
                this.setState({
                  showTicketNumberAlert: false
                });
              }}
              type={'warning'}
            />
          )}
          {this.state.showDispatchClaimsAlert && (
            <Alert
              styleClass="addToCartAlert"
              message={
                // 'Maximum allowable length for Dispatch/Claims marking is 15 characters'
                `${t('productFieldErrors.maxDispatchClaimsMarkingErr', {
                  count: 15
                })}`
              }
              icon={'rpds-warning'}
              handleCloseAlert={() => {
                this.setState({
                  showDispatchClaimsAlert: false
                });
              }}
              type={'warning'}
            />
          )}
          {this.state.showCartAlert ? (
            <Alert
              styleClass="addToCartAlert"
              message={t(alertConfig.message)}
              icon={alertConfig.icon}
              handleCloseAlert={this.handleCloseCartAlert}
              type={alertConfig.type}
            >
              <a
                href={cartUrl()}
                onClick={goToCart}
                className="goToCartLink"
              >{`${t('menu.goTo')} ${t('common.cart')}`}</a>
            </Alert>
          ) : (
            <React.Fragment />
          )}
        </div>
        <div
          className="rp-part-details-model-desktop--close-modal-icon"
          onClick={e => this.props.handleClose()}
        >
          <span>Close</span>
          <i className="rpds-close" />
        </div>
        <div className="rp-part-details-model-desktop-top Roboto">
          <div className="rp-part-details-model-desktop-top-left">
            <div className="rp-part-details-model-desktop--images">
              <div className="rp-part-details-model-desktop--mini-images">
                {this.props.part.images && (
                  <Carousel>
                    {this.props.part.images.map((image, i) => (
                      <div
                        className="rp-part-details-model-desktop--mini-image"
                        key={i}
                        style={{
                          backgroundImage: `url(${image})`
                        }}
                        onClick={e => this.handleClicMiniImage(image)}
                      />
                    ))}
                  </Carousel>
                )}
              </div>
              <div>
                <div
                  className="image-container"
                  style={{
                    backgroundImage: `url(${this.state.mainImage})`
                  }}
                  onClick={e => this.handleClicMainImage()}
                />
                {this.state.showModalImage && (
                  <Modal
                    handleCloseModal={this.handleCloseImageModal}
                    showClose={true}
                  >
                    <img
                      className="rp-part-details-model-desktop--modal--image"
                      src={this.state.mainImage}
                    />
                  </Modal>
                )}
              </div>
            </div>
          </div>
          <div className="rp-part-details-model-desktop--info">
            <p className="rp-part-details-model-desktop--info--name">
              <span>{this.props.part.name}</span>
              {this.props.part.specialOrder && (
                <span className="rp-part-details-model-desktop--info--special-order">
                  <span className={`rpds-new-releases special-order-icon`} />
                  <span>Special Order</span>
                </span>
              )}
            </p>
            <p className="rp-part-details-model-desktop--info--product-number">
              {this.props.part.productNumber}
            </p>
            <p className="rp-part-details-model-desktop--info--description">
              {this.props.part.description}
            </p>
            <div className="rp-part-details-model-desktop--info--prices-bar">
              <div className="rp-part-details-model-desktop--info--stock-text">
                <label className="rp-part-details-model-desktop--info--stock">
                  <span
                    title={this.props.part.stateDescription}
                    className={
                      this.props.part.inStock
                        ? `rpds-check-circle stock-success-icon`
                        : `rpds-error stock-error-icon`
                    }
                  />
                  <span title={this.props.part.stateDescription}>
                    {this.props.part.state}
                  </span>
                  <IconMessage
                    icon={'rpds-error'}
                    message={this.props.part.stateDescription}
                    className={'rp-part-details-model-info-icon'}
                  />
                </label>
                {/* <div className="rp-part-details-model-desktop--info--supplier">
                  <span className="rp-part-details-model-desktop--info--supplier--count">
                    {this.props.part.supplierQuantity}
                  </span>
                  <div>Manufacturer Quantity</div>
                </div> */}
                <div className="rp-part-details-model-desktop--info--extras">
                  {this.props.part.extraProducts &&
                    this.props.part.extraProducts.length > 0 && (
                      <span className="rp-part-details-model-desktop--info--extra">
                        <p>{getExtraStatus(this.props.part.extraProducts)}</p>
                      </span>
                    )}
                  {this.props.part.extraTotalAmount > 0 && (
                    <b className="rp-part-details-model-desktop--info--extra-text">
                      {env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                        ? `An extra charge of ${accounting.formatMoney(
                            this.props.part.extraTotalAmount
                          )} may apply at checkout.`
                        : `An extra charge of ${accounting.formatMoney(
                            this.props.part.extraTotalAmount
                          )} will apply at checkout.`}
                    </b>
                  )}
                </div>
              </div>

              <div className="rp-part-details-model-desktop--info--stock-text">
                {// check if cart is empty or it is on shipping show default warehouse
                this.props.cartItemsCount === 0 ||
                this.props.cartDeliverMethod.toLocaleLowerCase() === 'shipping'
                  ? this.props.part.warehouseDesc
                  : this.props.cartDeliverLocation.name.search(
                      ' PICK UP ONLY'
                    ) > 0 && env.REACT_APP_BASE_ENVIRONMENT === 'US'
                  ? this.props.cartDeliverLocation.name.slice(
                      0,
                      this.props.cartDeliverLocation.name.search(
                        ' PICK UP ONLY'
                      ) + 1
                    )
                  : this.props.cartDeliverLocation.name}
              </div>

              {this.props.isLoggedIn && (
                <div className="row">
                  {!this.props.showOnlyMSRP && (
                    <div className="col-4">
                      <label className="rp-part-details-model-desktop--info--price-title">
                        Your price
                      </label>
                      <p className="rp-part-details-model-desktop--info--price">
                        {accounting.formatMoney(this.props.part.price)}
                      </p>
                    </div>
                  )}
                  <div className="col-4">
                    <label className="rp-part-details-model-desktop--info--price-title">
                      MSRP
                    </label>
                    <p className="rp-part-details-model-desktop--info--price">
                      {accounting.formatMoney(this.props.part.msrp)}
                    </p>
                  </div>
                </div>
              )}
            </div>
            <div className="rp-divider" />
            <div className="rp-paret-details-model--form">
              <p className="rp-paret-details-model--form--title">
                Order this part
              </p>
              <div className="rp-paret-details-model--form-inputs rp-paret-details-model--form-inputs--qty">
                <label>Qty:</label>
                <input
                  name="qty"
                  type="number"
                  min="1"
                  value={this.state.qty}
                  onChange={this.handleInputQtyChange}
                />
              </div>
              <div className="rp-paret-details-model--form-inputs rp-paret-details-model--form-inputs--shipment">
                <label>Shipment marking:</label>
                <input
                  name="shipmentMarking"
                  type="text"
                  value={this.state.shipmentMarking}
                  onChange={this.handleInputShipmentMarkingChange}
                  maxLength={30}
                />
              </div>
              {env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? (
                <div className="rp-paret-details-model--form-inputs rp-paret-details-model--form-inputs--ticket">
                  <label>Ticket / Dispatch #:</label>
                  <input
                    name="ticketNumber"
                    type="text"
                    value={this.state.ticketNumber}
                    onChange={this.handleInputTicketNumberChange}
                    maxLength={10}
                  />
                </div>
              ) : (
                this.props.warranties.length > 0 && (
                  <React.Fragment>
                    <div className="rp-paret-details-model--form-inputs rp-paret-details-model--form-inputs--warranty">
                      <label>Add Warranty Provider:</label>
                      <div
                        onClick={this.handleShowDropDown}
                        className="combobox dropdown"
                      >
                        <div tabIndex={0} className="dropdown-box">
                          {this.state.warrantyProvider}
                        </div>
                        <div tabIndex={-1} className="downarrow">
                          <span className="rpds-expand-more" />
                        </div>
                        {this.state.showDropDown && (
                          <div className="dropdown-list">
                            {this.props.warranties.map(warranty => (
                              <div
                                className="dropdown-list-option"
                                key={warranty.providerNumber}
                                onClick={e =>
                                  this.handleSelectWarrantyProviderChange(
                                    warranty
                                  )
                                }
                              >
                                {warranty.warrantyClaimNumber}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="rp-paret-details-model--form-inputs rp-paret-details-model--form-inputs--claims">
                      <label>Dispatch/Claims:</label>
                      <input
                        name="claims"
                        type="text"
                        value={this.state.claims}
                        placeholder="#"
                        onChange={this.handleInputClaimsChange}
                        maxLength={15}
                      />
                    </div>
                  </React.Fragment>
                )
              )}
            </div>

            <div className="rp-divider" />
          </div>
        </div>
        {this.state.showBackorderAlert && (
          <Alert
            type={'info'}
            styleClass={'rp-part-details-model-desktop--alert'}
            message={
              env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                ? `${t('common.itemsBackOrderedOnly')}`
                : `${this.state.qty -
                    this.props.part
                      .warehouseQty} item(s) will be backordered. We will ship them as soon as the stocks are available for shipment.`
            }
            icon={'rpds-shipping'}
            handleCloseAlert={this.handleCloseAlert}
          />
        )}
        <div className="rp-part-details-model-desktop--form--buttons">
          <button
            className="secondary-button rp-part-details-model-desktop--form--button button-details"
            onClick={this.handleOnClicDetails}
          >
            More Info
          </button>
          <AddToListMenu
            label="Add to list"
            part={this.props.part as any}
            category=''
            mfc=''
            className="rp-part-details-model-desktop--form--button button-list"
            height={'48px'}
          />
          {this.getAddToCartButton()}
        </div>
      </div>
    );
  }
}

export default PartDetailsModelDesktop;
